import React, { Component } from 'react';
import style from './index.module.css';

class Chapter10 extends Component<any> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { status, rank, higherSocRatio, beatRatio, qrCode } = this.props.data;

    return (
      // @ts-ignore
      <div className={style.posterPageBox} ref="posterPageBox">
        <div className={style.posterBgPage} />
        <div className={style.posterContent}>
          <div>
            {/* <div className={style.xpWhiteIconBox} /> */}
            <p className={style.posterText}>
              <span className={style.postTitleText}>我的充电习惯</span>
              <br />
              <span className={style.postTitleText}>评级:</span>
              <span className={style.postTitleBlueText}>{rank}级</span>
              <br />
              <br />
              <span className={style.postBeatBlackText}>打败全国</span>
              <span className={style.posterBigText}>{beatRatio || '--%'}</span>
              <span className={style.postBeatBlackText}>小鹏车主</span>
            </p>
            <p className={style.posterTipsText}>
              2021年，你的充电电量超过90%以上的次数占比
              <br />为{higherSocRatio}，
              <span>
                {status === 1
                  ? '请继续保持良好的充电习惯哦'
                  : '适当降低比例，更有利于电池健康哦'}
              </span>
            </p>
          </div>
        </div>
        <div className={style.posterBottomBox}>
          <div className={style.xpChargeStationBox}>
            <p className={style.leftMsgText}>
              <span className={style.heightText}>小鹏超充</span>
              <br />
              实现337城全覆盖，
              <br />
              随时随地伴你满电出发
            </p>
          </div>
          <div className={style.codeMsgBox}>
            <div className={style.qrCodeBox}>
              <img
                style={{ width: '100%', height: '100%' }}
                src={qrCode}
                alt=""
              />
            </div>
            <p
              className={style.posterTipsText}
              style={{ opacity: 0.6, fontWeight: 500, textAlign: 'center' }}
            >
              扫码二维码 下载APP
              <br />
              <span>查看我的年度充电报告</span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Chapter10;
